<template>
  <el-dialog title="救护车定位" :append-to-body="true" :visible.sync="showTag" width="90%">
    <div class="relative">
      <div :style="heightStyle" id="bigmap" ref="bigmap"></div>
      <div class="absolute time flex aic jcc fs16" v-if="showTime&&traceList.length">{{ distance }}({{ time }})</div>
    </div>
  </el-dialog>
</template>

<script>
import {staffService} from "../service/staff";
import {MapMixin} from "../mixins";

export default {
  name: "big-map-dialog",
  mixins: [MapMixin],
  data() {
    return {
      showTag: false,
      heightStyle: {
        margin: '-30px -20px',
        height: `${window.innerHeight - 55 - 100 - 100}px`
      }
    }
  },
  computed: {},
  mounted() {
    Log('big map dialog mounted')
  },
  watch: {
    info() {
      this.getDriving();
    }
  },
  methods: {
    show() {
      this.showTag = true;
      this.$nextTick(() => {
        this.init();
      })
    },
    hide() {
      this.showTag = false;
    },
    init() {
      const el = this.$refs.bigmap;
      if (el) {
        setTimeout(() => {
          this.initMap();
        }, 200)
      }
      // eslint-disable-next-line no-undef
    },
    initMap() {
      this.map = new AMap.Map("bigmap", {
        zoom: 15,
        resizeEnable: true,
        center: [120.209947, 30.245853]
      });
      this.getDriving();
    }
  },
}
</script>

<style scoped lang="scss">
.time {
  color: white;
  left: -20px;
  top: 0;
  padding: 20px 40px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.5);
}
</style>
